const cartTrustBadges = (element, callback) => {
    const maxWaitTime = 10000;
    const interval = 50;
    let elapsedTime = 0;

    const waitingInterval = setInterval(() => {
        const selector = document.querySelector(element);
        if (selector) {
            callback();
            clearInterval(waitingInterval);
        } else {
            elapsedTime += interval;
            if (elapsedTime >= maxWaitTime) {
                clearInterval(waitingInterval);
            }
        }
    }, interval);
};

cartTrustBadges("#rebuy-cart", () => {
    const cartObserverTrustBadges = new MutationObserver(() => {

        const checkMark = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="9" viewBox="0 0 13 9" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2803 0.21967C12.5732 0.512563 12.5732 0.987437 12.2803 1.28033L5.28033 8.28033C4.98744 8.57322 4.51256 8.57322 4.21967 8.28033L0.21967 4.28033C-0.0732233 3.98744 -0.0732233 3.51256 0.21967 3.21967C0.512563 2.92678 0.987437 2.92678 1.28033 3.21967L4.75 6.68934L11.2197 0.21967C11.5126 -0.0732233 11.9874 -0.0732233 12.2803 0.21967Z" fill="#1BB250"/>
            </svg>`;

        const trustBadges = document.createElement("div");
        trustBadges.className = "cart-trust-badges";

        const settings = window.cartTrustBadgesSettings || {};
        const badgeTexts = [
            settings.badge1 || "30 Day Money Back Guarantee",
            settings.badge2 || "Free Shipping On All Orders",
            settings.badge3 || "Secure SSL Checkout",
            settings.badge4 || "24/7 Customer Support"
        ];

        trustBadges.innerHTML = `
            <div class="trust_badges_swiper swiper">
                <div class="swiper-wrapper">
                    ${badgeTexts.map(text => `
                        <div class="swiper-slide" style="width: auto; white-space: nowrap;">
                            ${checkMark} <p class="trust-badges__text"> ${text} </p>
                        </div>
                    `).join('')}
                    ${badgeTexts.map(text => `
                        <div class="swiper-slide" style="width: auto; white-space: nowrap;">
                            ${checkMark} <p class="trust-badges__text"> ${text} </p>
                        </div>
                    `).join('')}
                </div>
            </div>
            <div class="trust-badges__badges">
                <h3>${settings.title}</h3>
                <img src="https://cdn.shopify.com/s/files/1/0356/1596/5321/files/trust-badges.webp" alt="Trust Badges" width="100%" height="auto" />
            </div>
        `;

        setTimeout(() => {
            function initSwiper() {
                if (typeof Swiper !== 'undefined') {
                    const cartTrustBadgesSwiper = new Swiper('.trust_badges_swiper', {
                        slidesPerView: 'auto',
                        spaceBetween: 16,
                        loop: true,
                        speed: 10000,
                        allowTouchMove: false,
                        freeMode: {
                            enabled: true,
                            momentum: false,
                        },
                        autoplay: {
                            delay: 0,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: false,
                        },
                    });
                } else {
                    setTimeout(initSwiper, 100);
                }
            }

            initSwiper();
        }, 50)

        const cartTarget = document.querySelector(".rebuy-cart__flyout-subtotal");
        if (cartTarget && !document.querySelector(".cart-trust-badges")) {
            cartTarget.before(trustBadges);
        }
    })

    cartObserverTrustBadges.observe(document.querySelector("#rebuy-cart"), {
        attributes: true,
        attributeFilter: ["class"]
    });
});